import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../DataDomain';
import { IBigScreenCmsMoodsResponse, IBigScreenCmsGamesResponse } from '../entity/interface/iBigScreenCmsMoods';
import { IBigScreenCmsRepository } from '../core/repositories/interfaces/iBigScreenCmsRepository';
import { IBigScreenCmsUseCase } from '../core/repositories/interfaces/iBigScreenCmsUseCase';

class BigScreenCmsUseCase implements IBigScreenCmsUseCase {
    private get bigScreenCmsRepo(): IBigScreenCmsRepository {
        return container.resolve<IBigScreenCmsRepository>(DI.REPOSITORIES.IBigScreenCmsRepository);
    }

    constructor() {}

    async getMoods(): Promise<IBigScreenCmsMoodsResponse['data']> {
        const response = await this.bigScreenCmsRepo.getMoods();
        return response.data;
    }
    async getGames(): Promise<IBigScreenCmsGamesResponse['data']> {
        const response = await this.bigScreenCmsRepo.getGames();
        return response.data;
    }
}

export default BigScreenCmsUseCase;
